var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99477 14.666C4.31287 14.666 1.32812 11.6812 1.32812 7.99934C1.32812 4.31744 4.31289 1.33267 7.99479 1.33267C10.9799 1.33267 13.4786 3.2946 14.3281 5.99934H12.6614",
    stroke: "#E6E6F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99609 5.33267V7.99934L9.32943 9.33267",
    stroke: "#E6E6F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6328 8.66601C14.6526 8.44659 14.6628 8.22421 14.6628 7.99934M9.99609 14.666C10.2238 14.5911 10.4463 14.5036 10.6628 14.4045M13.8565 11.3327C13.9851 11.085 14.0997 10.8282 14.1994 10.5635M12.1244 13.4855C12.3541 13.2954 12.5715 13.0899 12.7753 12.8703",
    stroke: "#E6E6F5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/recent.db70826a433b8ff5fa5083af5a40dda8.svg";
export { ForwardRef as ReactComponent };